import React from 'react';
import PropTypes from 'prop-types';
import CurrencyHelper from '../../Helpers/CurrencyHelper';

const View = ({ value, show, basicCoverageRef, ACSellingLiquor }) =>
  show && (
    <>
      <div
        className="row justify-content-between mt-2 pt-1"
        ref={basicCoverageRef}
      >
        <div className="col-auto my-auto">
          <p className="mb-0">Limit for each incident (Occurrence)</p>
        </div>
        <div className="col-auto my-auto">
          {new CurrencyHelper().setValue(value).dollars()}
        </div>
      </div>
      {!ACSellingLiquor && (
        <div className="row pt-1">
          <p className="col-auto mb-0">Includes host liquor</p>
        </div>
      )}
      <div className="row justify-content-between mt-3 pt-1">
        <p className="col-auto mb-0 font-weight-bold" htmlFor="fieldCoverage">
          Damage to Rented Premises
        </p>
        <div className="col-auto my-auto">
          {new CurrencyHelper().setValue(250000).dollars()}
        </div>
      </div>
    </>
  );
View.propTypes = {
  value: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  basicCoverageRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  ACSellingLiquor: PropTypes.bool.isRequired,
};

export default View;
